import getScrollableElement from './get-scrollable-element';

const SCROLL_UP = -1;
const SCROLL_DOWN = 1;

let scrolledElement = null;
let scrollSpeed = 0;
let scrollDirection = 1;
let scrollTimer;
let scrollingTop = 0;

const setDocument = (document) => {
  scrolledElement = getScrollableElement(document);
};

const scrollTop = () => scrollingTop;

const isScrolling = () => scrollSpeed > 0;

const step = () => {
  scrollingTop += scrollSpeed * scrollDirection;
  if (scrollingTop <= 0) {
    scrollingTop = 0;
  }

  scrolledElement.scrollTop = scrollingTop;
};

const start = () => {
  if (scrolledElement) {
    scrollingTop = scrolledElement.scrollTop;
    scrollTimer = setInterval(step, 10);
  }
};

const setSpeed = (speed) => {
  scrollSpeed = speed;
};

const setDirection = (direction) => {
  scrollDirection = direction;
};

const stop = () => {
  clearInterval(scrollTimer);
  scrollSpeed = 0;
  scrollDirection = 1;
  scrollTimer = null;
  scrollingTop = 0;
};

const reset = () => {
  stop();
  scrolledElement = null;
};

export default {
  scrollTop,
  isScrolling,
  step,
  start,
  setSpeed,
  setDirection,
  stop,
  setDocument,
  reset,
  SCROLL_UP,
  SCROLL_DOWN,
};
